module.exports = __webpack_public_path__ + "img/macaucover_logo.fa0b1515.png";